{
  "name": "ngx-oepa-payment",
  "version": "1.5.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:main": "ng build --configuration production --output-hashing=all",
    "build:dev": "ng build --configuration development --output-hashing=all",
    "build:test": "ng build --configuration test --output-hashing=all",
    "build:staging": "ng build --configuration staging --output-hashing=all",
    "build:project2": "ng build --configuration project2 --output-hashing=all",
    "watch": "ng build --watch --configuration local-dev",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.10",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/material": "^18.2.10",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@ohioepa/oepa-anonymous-auth-lib": "0.0.2",
    "@ohioepa/oepa-ebiz-lib": "^1.2.0",
    "@ohioepa/oepa-iop-auth-lib": "^1.0.0",
    "angular-oauth2-oidc": "^17.0.0",
    "ng-recaptcha": "^13.2.1",
    "rxjs": "~7.8.0",
    "sha.js": "^2.4.11",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.7",
    "@angular/cli": "^18.2.7",
    "@angular/compiler-cli": "^18.2.0",
    "@types/jasmine": "~5.1.0",
    "@types/sha.js": "^2.4.4",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.2"
  }
}
